import { of } from "rxjs";
import {
  catchError,
  filter,
  map,
  mapTo,
  mergeMap,
  throttleTime,
} from "rxjs/operators";
import { isActionOf } from "typesafe-actions";
import { documentMetadata } from "../../state/config/config.selector";
import * as userActions from "../../state/user/user.actions";
import { userToken } from "../../state/user/user.selector";
import * as workspacesActions from "../../state/workspaces/workspaces.actions";
import { waitForConfigLoaded, waitForToken } from "../helpers/waitForState";
import type { AppEpic } from "../types";

export const getMyTonnageEpic: AppEpic = (
  action$,
  state$,
  { documentIdv3Requests },
) =>
  action$.pipe(
    filter(
      isActionOf([
        workspacesActions.getMyTonnage.request,
        userActions.login.success,
      ]),
    ),
    waitForToken(state$),
    mergeMap(() =>
      documentIdv3Requests
        .getMyWorkspacesTonnage(
          documentMetadata(state$.value),
          userToken(state$.value),
        )
        .pipe(
          map((myTonnage) => workspacesActions.getMyTonnage.success(myTonnage)),
          catchError((error) =>
            of(workspacesActions.getMyTonnage.failure(error)),
          ),
        ),
    ),
  );

// TODO: Why not just fetch my tonnage after "user-specific" feature flags have been fetched? ¯\_(ツ)_/¯
// NOTE: The request for my tonnage must be after user-specific feature flags have been retrieved. Doing this after populating the workspaces is one way to do this.
export const periodicallyFetchMyTonnageEpic: AppEpic = (action$) =>
  action$.pipe(
    filter(isActionOf(workspacesActions.loadWorkspaces.request)),
    throttleTime(1000 * 60 * 5), // 5 minutes
    mapTo(workspacesActions.getMyTonnage.request()),
  );

export const getUserByIdTonnageEpic: AppEpic = (
  action$,
  state$,
  { documentIdv3Requests },
) =>
  action$.pipe(
    filter(isActionOf(workspacesActions.getUserTonnage.request)),
    waitForToken(state$),
    waitForConfigLoaded(state$),
    mergeMap((action) =>
      documentIdv3Requests
        .getUserWorkspacesTonnageById(
          documentMetadata(state$.value),
          userToken(state$.value),
          action.payload,
        )
        .pipe(
          map((res) => workspacesActions.getUserTonnage.success(res)),
          catchError((error) =>
            of(workspacesActions.getUserTonnage.failure(error)),
          ),
        ),
    ),
  );

export const recalculateUserTonnageEpic: AppEpic = (
  action$,
  state$,
  { documentIdv3Requests },
) =>
  action$.pipe(
    filter(isActionOf(workspacesActions.recalculateUserTonnage.request)),
    waitForToken(state$),
    mergeMap((action) =>
      documentIdv3Requests
        .recalculateUserTonnage(
          documentMetadata(state$.value),
          userToken(state$.value),
          action.payload,
        )
        .pipe(
          map(() => workspacesActions.recalculateUserTonnage.success()),
          catchError((error) =>
            of(workspacesActions.recalculateUserTonnage.failure(error)),
          ),
        ),
    ),
  );
